import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

const _FM_PaymentmethodFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [CFormData, setCFormData] = useState({});
  const [COptions, setCOptions] = useState({});
  const [CFields, setCFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderPaymentmethodList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderPaymentmethodList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  useEffect(() => {
    setCFormData({
      ...CFormData,
      payment_method: formData.id
    })
  }, [formData.id])


  useEffect(() => {
    if (formData._country_specifics && Object.keys(formData._country_specifics).length > 0) {
      let countryObjectName = "payment_method_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
      if (formData[countryObjectName][0]) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method-"
            + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCFormData(response.data.data);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
      const transformedCountry = Object.keys(formData._country_specifics)[0]
        ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/PaymentMethod" + transformedCountry,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setCFields(response.data.editable_fields);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData._country_specifics])

  useEffect(() => {
    CFields.map((field, index) => {
      if (field.type.includes("Enum")) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/" + field.name.replaceAll('_', '-'),
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCOptions({
              ...COptions,
              [field.name]: Object.values(response.data.data).flat()
            })
          })
          .catch(error => {

          })
      }
    })
  }, [CFields])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
        className="pi pi-exclamation-triangle blocked-ui-message-icon"
        aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('paymentmethod_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  {formData.id &&
                    <Button type="submit" aria-label={t('save_and_close')}
                            loading={loading}
                            onClick={() => {
                              props = {...props, closeForm: true}
                            }}
                            className="p-button-success p-ml-2">
                      <span>
                        <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                      </span>
                    </Button>
                  }
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
        <BlockUI blocked={!formData.id} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
          className="pi pi-exclamation-triangle blocked-ui-message-icon"
          aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {CFields && CFields[0] ? (
                <>
                  {Object.keys(formData._country_specifics)[0].toUpperCase()}
                </>
              ) : (
                <>
                  {t('country_specific_settings')}
                </>
              )}
            </h3>
            <div className={"p-grid"}>
              {CFields && CFields[0] ? (
                <>
                  {CFields.map((field, index) => {
                    if (field.type.includes("Text")) {
                      return (
                        <>
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <label htmlFor={field.name}>{t(field.name)}</label>
                              <span className="p-d-block">
                                      <InputText id={field.name}
                                                 disabled={!formData.id}
                                                 onChange={(e) => {
                                                   setCFormData({
                                                     ...CFormData,
                                                     [field.name]: e.target.value
                                                   })
                                                 }}
                                                 value={CFormData[field.name]}
                                      />
                                    </span>
                            </div>
                          </div>
                        </>
                      )
                    }
                    if (field.type.includes("Enum")) {
                      return (
                        <>
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <label htmlFor={field.name}>{t(field.name)}</label>
                              <span className="p-d-block">
                                      <Dropdown  options={COptions[field.name]}
                                                filter
                                                optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                                optionValue="key"
                                                id={field.name}
                                                emptyMessage={t('empty_message')}
                                                onChange={(e) => {
                                                  setCFormData({
                                                    ...CFormData,
                                                    [field.name]: e.value
                                                  })
                                                }}
                                                value={CFormData[field.name]}
                                      />
                                    </span>
                            </div>
                          </div>
                        </>
                      )
                    }
                  })}
                </>
              ) : (
                <div className={"p-col"}>
                  <p>{t('country_specific_settings_after_save')}</p>
                </div>
              )}
            </div>
            <div className={"p-grid"}>
              <div className={"p-col p-text-right p-col-align-center"}>
                <Button type="button" label={t('save')} icon={"pi pi-save"}
                        loading={loading}
                        disabled={!formData.id}
                        onClick={() => {
                          setLoading(true)
                          if (CFormData.id) {
                            axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method-"
                              + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + CFormData.id,
                              CFormData,
                              {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                setCFormData(response.data.data);
                                setLoading(false)
                                window.App.toastShow('success', t('success'), response.data.message)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                              })
                          } else {
                            axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method-"
                              + Object.keys(formData._country_specifics)[0].toLowerCase(),
                              CFormData,
                              {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                setCFormData(response.data.data);
                                setLoading(false)
                                window.App.toastShow('success', t('success'), response.data.message)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                              })
                          }

                        }}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
          </Panel>
        </BlockUI>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_PaymentmethodFormComponent);
